function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { isArray, isString } from 'vega-util';
import { pick } from './util';
export function extractTitleConfig(titleConfig) {
  var anchor = titleConfig.anchor,
      frame = titleConfig.frame,
      offset = titleConfig.offset,
      orient = titleConfig.orient,
      color = titleConfig.color,
      subtitleColor = titleConfig.subtitleColor,
      subtitleFont = titleConfig.subtitleFont,
      subtitleFontSize = titleConfig.subtitleFontSize,
      subtitleFontStyle = titleConfig.subtitleFontStyle,
      subtitleFontWeight = titleConfig.subtitleFontWeight,
      subtitleLineHeight = titleConfig.subtitleLineHeight,
      subtitlePadding = titleConfig.subtitlePadding,
      rest = _objectWithoutProperties(titleConfig, ["anchor", "frame", "offset", "orient", "color", "subtitleColor", "subtitleFont", "subtitleFontSize", "subtitleFontStyle", "subtitleFontWeight", "subtitleLineHeight", "subtitlePadding"]);

  var titleMarkConfig = _objectSpread(_objectSpread({}, rest), color ? {
    fill: color
  } : {}); // These are non-mark title config that need to be hardcoded


  var nonMark = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, anchor ? {
    anchor: anchor
  } : {}), frame ? {
    frame: frame
  } : {}), offset ? {
    offset: offset
  } : {}), orient ? {
    orient: orient
  } : {}); // subtitle part can stay in config.title since header titles do not use subtitle


  var subtitle = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, subtitleColor ? {
    subtitleColor: subtitleColor
  } : {}), subtitleFont ? {
    subtitleFont: subtitleFont
  } : {}), subtitleFontSize ? {
    subtitleFontSize: subtitleFontSize
  } : {}), subtitleFontStyle ? {
    subtitleFontStyle: subtitleFontStyle
  } : {}), subtitleFontWeight ? {
    subtitleFontWeight: subtitleFontWeight
  } : {}), subtitleLineHeight ? {
    subtitleLineHeight: subtitleLineHeight
  } : {}), subtitlePadding ? {
    subtitlePadding: subtitlePadding
  } : {});

  var subtitleMarkConfig = pick(titleMarkConfig, ['align', 'baseline', 'dx', 'dy', 'limit']);
  return {
    titleMarkConfig: titleMarkConfig,
    subtitleMarkConfig: subtitleMarkConfig,
    nonMark: nonMark,
    subtitle: subtitle
  };
}
export function isText(v) {
  return isString(v) || isArray(v) && isString(v[0]);
}